import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_TRANSACTION_SOURCE_DEF,
} from "./actionTypes"

import {
    getTransactionSourceDefListSuccess,
    transactionSourceDefApiError
} from "./actions"

//Include Both Helper File with needed methods
import {
    GetAllTransactionSourceDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetTransactionSourceDefList() {
  try {
    const response = yield call(GetAllTransactionSourceDef)
    yield put(getTransactionSourceDefListSuccess(response))
  } catch (error) {
    yield put(transactionSourceDefApiError(error))
  }
}

function* transactionSourceDefSaga() {
    yield takeEvery(GET_TRANSACTION_SOURCE_DEF,onGetTransactionSourceDefList)
}

export default transactionSourceDefSaga